import { Api } from "@/api/axios";

export default class SeriesApi extends Api {
  constructor(baseUrl, seriesEndpointUrl) {
    super();
    this.seriesEndpointUrl = baseUrl + seriesEndpointUrl;
  }

  /**
   * Search OMDB for a series by name.
   */
  search(series) {
    return this.post(`${this.seriesEndpointUrl}/lookup`, { query: series })
      .then((response) => response)
      .catch((error) => {
        throw error;
      });
  }

  /**
   * Start tracking the series.
   */
  track(series) {
    return this.post(`${this.seriesEndpointUrl}/track`, { seriesId: series })
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  }

  /**
   * Cast (or clear, with vote=null) a dislike/like/really_like vote.
   */
  vote(seriesId, vote) {
    return this.post(`${this.seriesEndpointUrl}/vote`, { seriesId, vote })
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  }

  /**
   * Stop tracking the series.
   */
  untrack(series) {
    return this.post(`${this.seriesEndpointUrl}/untrack`, { seriesId: series })
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  }

  /**
   * Fetch genre-grouped recommendations (optionally filtered to one genre).
   */
  recommendations(genreId) {
    const url = genreId
      ? `${this.seriesEndpointUrl}/recommendations?genre=${genreId}`
      : `${this.seriesEndpointUrl}/recommendations`;
    return this.get(url)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  }

  /**
   * Fetch the list of TV genres (for the Explore filter).
   */
  genres() {
    return this.get(`${this.seriesEndpointUrl}/genres`)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  }

  /**
   * Fetch all series for the currently authenticated user.
   */
  fetchAll() {
    return this.get(`${this.seriesEndpointUrl}`)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  }
}
